import {
  useWSModalCustom,
  WSControl,
  WSInfoBox,
  WSList,
  WSModal,
  WSModalCustomProps,
  WSText
} from "@wingspanhq/fe-component-library";
import { useState } from "react";
import { useMutationSetCoverageOnInsuranceCoverageMonitor } from "../../../../../query/insuranceCoverageMonitor/mutations/useMutationSetCoverageOnInsuranceCoverageMonitor";
import { WSErrorMessage } from "../../../../../components/WSErrorMessage/WSErrorMessage";

type Props = WSModalCustomProps<void> & {
  onSuccess: () => void;
  insuranceCoverageMonitorId: string;
  insuranceCoverageId: string;
};

export const ModalPartialMatchSubmitForReview: React.FC<Props> = ({
  insuranceCoverageMonitorId,
  insuranceCoverageId,
  onSuccess,
  onClose
}) => {
  const [checked, setChecked] = useState(false);

  const [
    setCoverageOnInsuranceCoverageMonitor,
    setCoverageOnInsuranceCoverageMonitorMeta
  ] = useMutationSetCoverageOnInsuranceCoverageMonitor();

  return (
    <WSModal
      title="Submit for review"
      actions={{
        alignment: "fill",
        buttons: [
          {
            kind: "Tertiary",
            label: "Back",
            onClick: () => onClose()
          },
          {
            label: "Submit for review",
            onAsyncClick: async () => {
              await setCoverageOnInsuranceCoverageMonitor(
                {
                  insuranceCoverageMonitorId,
                  insuranceCoverageId
                },
                {
                  onSuccess: () => {
                    onSuccess();
                    onClose();
                  }
                }
              );
            },
            disabled: !checked
          }
        ]
      }}
    >
      <WSList gap="XL">
        <WSText.ParagraphSm color="gray500">
          Are you sure you want to submit the partially matched policy for
          client review?
        </WSText.ParagraphSm>

        <WSInfoBox title="Important:">
          <p>
            If the policy does not provide the right coverage or is rejected by
            the client, you will need to seek new coverage and upload the
            relevant documents.
          </p>

          <WSControl
            type="checkbox"
            size="S"
            label="I have reviewed the partially matched policy I’ve selected and understand that once I submit it, the client has sole discretion to approve or reject it. I acknowledge that incomplete requirements may delay payments or put me at risk of non-compliance. As a contractor, it is my responsibility to maintain the required coverage and meet client requirements to remain compliant and ensure timely payment."
            value={checked}
            onChange={setChecked}
          />
        </WSInfoBox>

        <WSErrorMessage
          contextKey="Other"
          forceShowApiErrors
          error={setCoverageOnInsuranceCoverageMonitorMeta.error}
        />
      </WSList>
    </WSModal>
  );
};

export const useModalPartialMatchSubmitForReview = () =>
  useWSModalCustom(ModalPartialMatchSubmitForReview);
